// extracted by mini-css-extract-plugin
module.exports = {"MyName":"WelcomeText_MyName__lsomC","MyTitles":"WelcomeText_MyTitles__6qaO6","BackingRect":"WelcomeText_BackingRect__3b5H2"};